import React, { FC } from "react";
import styled from "styled-components";
import { Link, useHistory } from "react-router-dom";
import { StyledButton } from "../../components/header/header";
import { frontEnd } from "../../config/links";

const Hero: FC = () => {
  const history = useHistory();

  const handleTryForFreeClick = () => {
    history.push(frontEnd.register);
  };

  return (
    <>
      <BackgroundWrapper />
      <HeroSection>
        <HeroContainer>
          <ContentWrapper>
            <LeftContent>
              <Title>Master Your Medical Exams with GetThru</Title>
              <Description>
                Comprehensive preparation for a variety of medical <br />
                exams, from surgery to pathology and beyond.
              </Description>
              <ButtonGroup>
                <StyledButton
                  buttonVariant="primary"
                  style={{ height: 50, marginRight: 10 }}
                  onClick={handleTryForFreeClick}
                >
                  Try For Free
                </StyledButton>
                {/* <SecondaryButton to="/exams-list">
                  To Exams List
                </SecondaryButton> */}
              </ButtonGroup>
            </LeftContent>
            <RightContent
              data-aos="fade-in"
              data-aos-delay="100"
              data-aos-duration="600"
              data-aos-anchor-placement="top-center"
            >
              <HeroImage
                src="/assets/home/pixeltrue-study-from-books-1 1.webp"
                alt="Medical students studying"
              />
            </RightContent>
          </ContentWrapper>
        </HeroContainer>
      </HeroSection>
    </>
  );
};

const HeroSection = styled.section`
  position: relative;
  min-height: 605px;
  width: 100%;
`;

const BackgroundWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("/assets/home/home-hero-bg.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1;
`;

const HeroContainer = styled.div`
  max-width: 1440px;
  padding: 0 16px;
  margin: 0 auto;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 768px) {
    gap: 32px;
    flex-direction: row;
  }
`;

const LeftContent = styled.div`
  text-align: center;
  @media (min-width: 768px) {
    margin-top: 40px;
    width: 521px;
    text-align: left;
  }
`;

const RightContent = styled.div`
  @media (min-width: 768px) {
    width: 55%;
  }

  img {
    width: 100%;
    height: 100%;
  }
`;

const HeroImage = styled.img.attrs({
  loading: "eager" as const
})`
  width: 100%;
  height: auto;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 16px;

  @media (min-width: 768px) {
    font-size: 40px;
  }

  @media (min-width: 1024px) {
    font-size: 48px;
  }
`;

const Description = styled.p`
  color: #666;
  font-size: 18px;
  margin-bottom: 8px;

  @media (min-width: 640px) {
    margin-bottom: 40px;
  }

  br {
    display: none;
    @media (min-width: 640px) {
      display: block;
    }
  }
`;

const ButtonGroup = styled.div`
  flex-direction: row;
  justify-content: center;
  margin-bottom: 48px;

  @media (min-width: 768px) {
    margin-bottom: 16px;
    justify-content: flex-start;
  }
`;

const SecondaryButton = styled(Link)`
  display: inline-block;
  padding: 12px 32px;
  color: #6c63ff;
  border-radius: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: background-color 0.2s;
  font-size: 16px;

  &:hover {
    background-color: rgba(108, 99, 255, 0.1);
  }
`;

export default Hero;
